import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import RecuperarSenha from "@/pages/RecuperarSenha";

export const Route = createFileRoute("/recuperar-senha")({
  head: () => seoHead({
    title: "Recuperar Senha | Shopping do Bem",
    description: "Recupere sua senha do Shopping do Bem.",
    path: "/recuperar-senha", noindex: true,
  }),
  component: RecuperarSenha,
});
